module.exports = __webpack_public_path__ + "static/media/1350_Cart_Medical_thanksPopup.ec0256c2.png";